import { render, staticRenderFns } from "./Yoyaku.vue?vue&type=template&id=4ba872ea&scoped=true"
import script from "./Yoyaku.vue?vue&type=script&lang=ts"
export * from "./Yoyaku.vue?vue&type=script&lang=ts"
import style0 from "./Yoyaku.vue?vue&type=style&index=0&id=4ba872ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba872ea",
  null
  
)

export default component.exports